import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';
import { DEFAULT_DATE_RANGE_FILTER_SELECT_VALUE } from '../commonUI/DateRangeFilterSelect/DateRangeFilterSelect';
import { DateRangeKey } from '../commonUI/DateRangeFilterSelect/utils/generateDateRangeFilter';

export enum RanchSummaryTableMeasureEnum {
  perMeter = 'Per Meter',
  perPlant = 'Per Plant',
  totalCount = 'Total Count',
}

type DataGridTablesState = {
  ranchSummaryTableMeasure: RanchSummaryTableMeasureEnum;
  ranchSummaryTableDateRange: DateRangeKey;
  ranchSummaryTableNumRowsSelected: number | null;
  ranchSummaryClickedRowScanIDs: string[];
};

const initialState: DataGridTablesState = {
  ranchSummaryTableMeasure: RanchSummaryTableMeasureEnum.perMeter,
  ranchSummaryTableDateRange: DEFAULT_DATE_RANGE_FILTER_SELECT_VALUE,
  ranchSummaryTableNumRowsSelected: null,
  ranchSummaryClickedRowScanIDs: [],
};

export const dataGridTablesState = createSlice({
  name: 'dataGridTablesState',
  initialState,
  reducers: {
    initDataGridTablesState: () => initialState,
    setRanchSummaryTableMeasure: (
      state,
      action: PayloadAction<RanchSummaryTableMeasureEnum>
    ) => {
      state.ranchSummaryTableMeasure = action.payload;
    },
    setRanchSummaryTableDateRange: (
      state,
      action: PayloadAction<DateRangeKey>
    ) => {
      state.ranchSummaryTableDateRange = action.payload;
    },
    setRanchSummaryTableNumRowsSelected: (
      state,
      action: PayloadAction<number | null>
    ) => {
      state.ranchSummaryTableNumRowsSelected = action.payload;
    },
    addRanchSummaryClickedRowScanID: (state, action: PayloadAction<string>) => {
      state.ranchSummaryClickedRowScanIDs.push(action.payload);
    },
  },
});

export const {
  initDataGridTablesState,
  setRanchSummaryTableMeasure,
  setRanchSummaryTableDateRange,
  setRanchSummaryTableNumRowsSelected,
  addRanchSummaryClickedRowScanID,
} = dataGridTablesState.actions;

export const selectRanchSummaryTableMeasure = (state: RootState) =>
  state.dataGridTables.ranchSummaryTableMeasure;
export const selectRanchSummaryTableDateRange = (state: RootState) =>
  state.dataGridTables.ranchSummaryTableDateRange;
export const selectRanchSummaryTableNumRowsSelected = (state: RootState) =>
  state.dataGridTables.ranchSummaryTableNumRowsSelected;
export const selectRanchSummaryClickedRowScanIDs = (state: RootState) =>
  state.dataGridTables.ranchSummaryClickedRowScanIDs;

export const selectAllDataGridTablesState = (state: RootState) =>
  state.dataGridTables;

export default dataGridTablesState.reducer;
